import SanityClient from '@sanity/client';

const config = {
  projectId: 'u5zsoy4b', // find this at manage.sanity.io or in your sanity.json
  dataset: 'production', // this is from those question during 'sanity init'
  useCdn: true,
};

export const sanityClient = new SanityClient(config);
